import config from 'config';

//获取项目的配置
let projectSettings = {};
for (let k in config) {
	if (config[k].PROJECT_LABEL === process.env.PROJECT_LABEL) {
		projectSettings = config[k];
		break;
	}
}

function addZero(n) {
	return Number(n) > 9 ? n+'' : '0' + n;
}

function setCookie(name, value, expires, path, domain, secure) {
	//name value expires path为必选参数
	let today = new Date();
	today.setTime(today.getTime());
	if (expires) {
		expires = expires * 1000 * 60 * 60 * 24;
	}
	let expires_date = new Date(today.getTime() + (expires));
	// 去掉escape, 避免escape 把＋解析成空格   ---20160428
	//document.cookie = name + '=' + escape(value) +
	document.cookie = name + '=' + value +
		((expires) ? ';expires=' + expires_date.toGMTString() : '') +
		((path) ? ';path=' + path : '') +
		((domain) ? ';domain=' + domain : '') +
		((secure) ? ';secure' : '');
}

function getCookie(check_name) {
	let a_all_cookies = document.cookie.split(';');
	let a_temp_cookie = '';
	let cookie_name = '';
	let cookie_value = '';
	let b_cookie_found = false;
	for (let i = 0; i < a_all_cookies.length; i++) {
		a_temp_cookie = a_all_cookies[i].split('=');
		cookie_name = a_temp_cookie[0].replace(/^\s+|\s+$/g, '');
		if (cookie_name === check_name) {
			b_cookie_found = true;
			if (a_temp_cookie.length > 1) {
				cookie_value = unescape(a_temp_cookie[1].replace(/^\s+|\s+$/g, ''));
			}
			return cookie_value;
		}
		a_temp_cookie = null;
		cookie_name = '';
	}
	if (!b_cookie_found) {
		return null;
	}
}

function getQueryString(url, name) {
	//获取url中的参数
	let reg = new RegExp(name + '=([^&#]+)\\b');
	let r = url.match(reg);
	if (r !== null) {
		return unescape(r[1]);
	} else {
		return null;
	}
}

function setUrlQueryString(url, name, str) {
	//获取url中的参数,并且替换
	let reg = new RegExp('&' + name + '=([^&#]*)');
	let r = url.match(name);
	if (r !== null) {
		return url.replace(reg, '&' + name + '=' + str);
	} else {
		if (url.match(/\?/))
			return url + '&' + name + '=' + str;
		else
			return url + '?' + name + '=' + str;
	}
}


function reloadPage() {
	let href = window.location.href;
	//兼容android下面reload方法不生效的问题
	if (navigator.userAgent.toLowerCase().match(/android/)) {
		window.location.replace(href + (href.match(/\?/) ? '&' : '?') + '_rt_=' + (+new Date()));
	} else {
		window.location.reload(true);
	}
}

//页面跳转
//可以通过call方式调用绑定this，例如：util.linkTo.call(this,'url')
function linkTo(url) {
	let targetPath = getRouteBaseUrl() + url;
	if (this.props && this.props.history) {
		//如果绑定了组件的this
		this.props.history.push(targetPath);
	} else {
		window.location.href = targetPath;
	}

}

//页面replace
//可以通过call方式调用绑定this，例如：util.linkTo.call(this,'url')
function redirectTo(url) {
	let targetPath = getRouteBaseUrl() + url;
	let targetUrl = getRouteBaseUrl() + url;
	if (this.props && this.props.history) {
		//如果绑定了组件的this
		if (this.props.history.location.pathname !== targetPath)
			this.props.history.replace(targetUrl);
	} else {
		if (window.location.pathname !== targetPath)
			window.location.replace(targetPath);
	}
}


/**
 * 变量基本类型判断
 * @param arg
 * @returns {string}
 */
function varTypeStr(arg) {
	let typeofResult = typeof arg, result = '';
	switch (typeofResult) {
		case 'undefined':
			result = 'undefined';
			break;
		case 'string':
			result = 'string';
			break;
		case 'number':
			if (isNaN(arg)) {
				result = 'NaN';
			} else {
				result = 'number';
			}
			break;
		case 'object':
			if (arg === null) {
				result = 'null';
			} else if (arg instanceof Array) {
				result = 'array';
			} else {
				result = 'object';
			}
			break;
		case 'boolean':
			result = 'boolean';
			break;
		default:
			result = '';
			break;
	}
	return result;
}


/**
 * 是否为空判断, 模拟PHP的empty方法
 * @param arg
 * @returns {boolean}
 */
function empty(arg) {
	let typeStr = varTypeStr(arg), result = false;
	switch (typeStr) {
		case 'string':
			if (arg === '') {
				result = true;
			}
			break;
		case 'number':
			if (arg === 0) {
				result = true;
			}
			break;
		case 'NaN':
			result = true;
			break;
		case 'null':
			result = true;
			break;
		case 'undefined':
			result = true;
			break;
		case 'array':
			if (arg.length === 0) {
				result = true;
			}
			break;
		case 'object':
			if (Object.keys(arg).length === 0) {
				result = true;
			}
			break;
		case 'boolean':
			if (arg === false)
				result = true;
			break;
		default:
			result = false;
			break;
	}
	return result;
}

//获取屏幕高度
function getWindowHeight() {
	return window.innerHeight / window._scale_;
}

//获取路由默认的前缀path
function getRouteBaseUrl() {
	return empty(projectSettings) ? '' : (process.env.NODE_ENV === 'development' ? projectSettings.DEVELOPMENT_ROUTE_BASE_PATH : projectSettings.PRODUCT_ROUTE_BASE_PATH);
}

//获取线上api的请求域名
function getOnlineApiHost() {
	return empty(projectSettings) ? '' : projectSettings.API_ONLINE_HOST;
}

//获取刷新token的url
function getGetTokenUrl() {
	return empty(projectSettings) ? '' : projectSettings.GET_TOKEN_URL;
}

//获取app_id
function getAppId() {
	return empty(projectSettings) ? '' : projectSettings.APP_ID;
}


function parseUA() {
	let u = navigator.userAgent;
	let u2 = navigator.userAgent.toLowerCase();
	let clientV = u2.match(/.+chicken\/([0-9.]+)/);
	return { //移动终端浏览器版本信息
		trident: u.indexOf('Trident') > -1, //IE内核
		presto: u.indexOf('Presto') > -1, //opera内核
		webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
		gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') === -1, //火狐内核
		mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
		ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
		android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或uc浏览器
		iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
		iPad: u.indexOf('iPad') > -1, //是否iPad
		webApp: u.indexOf('Safari') === -1, //是否web应该程序，没有头部与底部
		iosv: u.substr(u.indexOf('iPhone OS') + 9, 3),
		wechat: !!u2.match(/micromessenger/g),
		wechatdevtools: !!u2.match(/wechatdevtools/g),  //是否是开发者工具
		weibo: !!u2.match(/weibo/g),
		taobao: u.indexOf('AliApp(TB') > -1,
		app: u2.indexOf('thefair') !== -1, //是否在app中
		client_v: u2.indexOf('thefair') !== -1 && (clientV && Number(clientV[1])) || 0
	};
}

// 判断Object相等
function isObjectValueEqual(a, b) {
    // Of course, we can do it use for in
    // Create arrays of property names
    var aProps = Object.getOwnPropertyNames(a);
    var bProps = Object.getOwnPropertyNames(b);

    // If number of properties is different,
    // objects are not equivalent
    if (aProps.length !== bProps.length) {
        return false;
    }

    for (var i = 0; i < aProps.length; i++) {
        var propName = aProps[i];

        // If values of same property are not equal,
        // objects are not equivalent
        if (a[propName] !== b[propName]) {
            return false;
        }
    }

    // If we made it this far, objects
    // are considered equivalent
    return true;
}

/**
 * 手机号格式检查
 * @param mobile
 * @returns {boolean}
 */
function checkMobileFormat(mobile) {
	let mobileRegExp = new RegExp(/^1[3|4|5|6|7|8|9]\d{9}$/);
	return mobileRegExp.test(mobile);
}

function addEventGa(category, action, label) {
	if (typeof ga !== 'undefined') {
		ga('send', 'event', category, action, label);
	}
	if(typeof _hmt !== 'undefined'){
		_hmt.push(['_trackEvent', category, action, label]);
	}
	if(typeof gtag !== 'undefined'){
		gtag('event', action, {
			'event_category': category,
			'event_label': label
		});
	}
	//umeng站长统计
	if(typeof _czc !== 'undefined'){
		_czc.push(["_trackEvent",category,action,label]);
	}
}

//预加载图片
function preloadImages(imageArray, callback) {
	if (imageArray) {
		let count = 0, len = imageArray.length;
		imageArray.forEach((src, index) => {
			let img = new Image();
			img.onload = () => {
				count++;
				callback && callback(index, count === len);
			};
			img.src = src;
		});
	}
}

/**
 * 阿拉伯数字转换为简写汉字
 * @param num
 * @returns {string}
 */
function arabiaToSimplifiedChinese(Num) {
	for (let i = Num.length - 1; i >= 0; i--) {
		Num = Num.replace(',', '');//替换Num中的“,”
		Num = Num.replace(' ', '');//替换Num中的空格
	}
	if (isNaN(Num)) { //验证输入的字符是否为数字
		//alert("请检查小写金额是否正确");
		return;
	}
	//字符处理完毕后开始转换，采用前后两部分分别转换
	let part = String(Num).split('.');
	let newchar = '';
	//小数点前进行转化
	for (let i = part[0].length - 1; i >= 0; i--) {
		if (part[0].length > 10) {
			//alert("位数过大，无法计算");
			return '';
		}//若数量超过拾亿单位，提示
		let tmpnewchar = '';
		let perchar = part[0].charAt(i);
		switch (perchar) {
			case '0': tmpnewchar = '零' + tmpnewchar;break;
			case '1': tmpnewchar = '一' + tmpnewchar; break;
			case '2': tmpnewchar = '二' + tmpnewchar; break;
			case '3': tmpnewchar = '三' + tmpnewchar; break;
			case '4': tmpnewchar = '四' + tmpnewchar; break;
			case '5': tmpnewchar = '五' + tmpnewchar; break;
			case '6': tmpnewchar = '六' + tmpnewchar; break;
			case '7': tmpnewchar = '七'+ tmpnewchar; break;
			case '8': tmpnewchar = '八'+ tmpnewchar; break;
			case '9': tmpnewchar = '九'+ tmpnewchar; break;
		}
		switch (part[0].length - i - 1) {
			case 0: tmpnewchar = tmpnewchar; break;
			case 1: if (perchar !== 0) tmpnewchar = tmpnewchar + '十'; break;
			case 2: if (perchar !== 0) tmpnewchar = tmpnewchar + '百'; break;
			case 3: if (perchar !== 0) tmpnewchar = tmpnewchar + '千'; break;
			case 4: tmpnewchar = tmpnewchar + '万'; break;
			case 5: if (perchar !== 0) tmpnewchar = tmpnewchar + '十'; break;
			case 6: if (perchar !== 0) tmpnewchar = tmpnewchar + '百'; break;
			case 7: if (perchar !== 0) tmpnewchar = tmpnewchar + '千'; break;
			case 8: tmpnewchar = tmpnewchar + '亿'; break;
			case 9: tmpnewchar = tmpnewchar + '十'; break;
		}
		newchar = tmpnewchar + newchar;
	}
	//替换所有无用汉字，直到没有此类无用的数字为止
	while (newchar.search('零零') !== -1 || newchar.search('零亿') !== -1 || newchar.search('亿万') !== -1 || newchar.search('零万') !== -1) {
		newchar = newchar.replace('零亿', '亿');
		newchar = newchar.replace('亿万', '亿');
		newchar = newchar.replace('零万', '万');
		newchar = newchar.replace('零零', '零');
	}
	//替换以“一十”开头的，为“十”
	if (newchar.indexOf('一十') === 0) {
		newchar = newchar.substr(1);
	}
	//替换以“零”结尾的，为“”
	if (newchar.lastIndexOf('零') === newchar.length - 1) {
		newchar = newchar.substr(0, newchar.length - 1);
	}
	return newchar;
}

//去除字符串两端的空格
function removeStrlrSpace(s){
	return s.replace(/(^\s*)|(\s*$)/g, '');
}


//根据配置绘制海报图，并导出base64,配置格式如下
// var data = {
//     canvas:{
//         width: 750,
//         height: 1218
//     },
//     item_list:[
//         {
//             type: 'image',
//             url: './B_female_1.png',
//             img_info: {
//                 width: 750,
//                 height: 1218
//             },
//             draw_info:{
//                 x: 0,
//                 y: 0,
//                 width: 750,
//                 height: 1218
//             }
//         },
//         {
//             type: 'text',
//             text: '胡仲春的甜心之一',
//             draw_info:{
//                 x: 375,
//                 y: 180,
//                 font: 'Bold 48px Arial',
//                 text_align: 'center',
//                 color: '#3A2920'
//             }
//         },
//         {
//             type: 'image',
//             url: './qrcode.png',
//             img_info: {
//                 width: 750,
//                 height: 1218
//             },
//             draw_info:{
//                 x: 584,
//                 y: 1068,
//                 width: 130,
//                 height: 130
//             }
//         }
//     ]
// }
function canvasDrawPoster(data, callback) {
	let canvas = document.createElement('canvas');
	let cxt = canvas.getContext('2d');

	//筛选出要使用的图片做预加载，所以图片加载完成之后，再进行绘制，否则无法保证绘制的层级
	let images = [], imagesCount = 0;
	let itemList = data.item_list;
	for (let i = 0; i < itemList.length; i++) {
		let item = itemList[i];
		if (item.type === 'image') {
			imagesCount++;
			images[i] = item;
		}
	}

	//预加载图片
	function preloadImage(images, callback) {
		let count = 0, len = images.length;
		for (let i = 0; i < len; i++) {
			let item = images[i];
			if (item) {
				let img = new Image();
				img.src = images[i].url;
				data.item_list[i].img = img;
				img.onload = function () {
					++count;
					if (count === imagesCount) {
						callback && callback(images);
					}
				};
			}
		}
	}

	function start(data) {
		canvas.width = data.canvas.width;
		canvas.height = data.canvas.height;

		let itemList = data.item_list;
		for (let i = 0; i < itemList.length; i++) {
			let item = itemList[i];
			if (item.type === 'image') {
				cxt.drawImage(item.img, item.draw_info.x, item.draw_info.y, item.draw_info.width, item.draw_info.height);
			} else if (item.type === 'text') {
				drawText(item);
			}
		}

		setTimeout(function () {
			let dataURL = canvas.toDataURL('image/png');
			callback && callback(dataURL);
		}, 100);

	}

	// 绘制文字
	function drawText(item) {
		cxt.font = item.draw_info.font;
		cxt.textAlign = item.draw_info.text_align;
		cxt.fillStyle = item.draw_info.color;
		cxt.fillText(item.text, item.draw_info.x, item.draw_info.y);
	}

	preloadImage(images, function (images) {
		start(data);
	});
}

//把class name的obj转成classNameStr
function getClassNames(classObj) {
	let classNameArray = [];
	for(let k in classObj){
		if(classObj[k]){
			classNameArray.push(k);
		}
	}

	return classNameArray.join(' ');
}

//获取元素的偏移量
function getOffset(ele) {
	let totalLeft = null, totalTop = null, par = ele.offsetParent;
	//首先加自己本身的左偏移和上偏移
	totalLeft += ele.offsetLeft;
	totalTop += ele.offsetTop;
	//只要没有找到body，我们就把父级参照物的边框和偏移也进行累加
	while (par) {
		//累加父级参照物本身的偏移
		totalLeft += par.offsetLeft;
		totalTop += par.offsetTop;
		par = par.offsetParent;
	}
	return {
		left: totalLeft,
		top: totalTop
	};
}

//performance 标记
function setPAMark(name) {
	window.performance && window.performance.mark(name);
}

//performance 记录两个mark之间的差
function setPAMeasure(name,startMarkName,endMarkName) {
	window.performance && window.performance.measure(name,startMarkName,endMarkName);
}

//performance 获取计算的详情
function getPAMeasure(name) {
	return window.performance && window.performance.getEntriesByName(name);
}

export default {
	addZero,
	isObjectValueEqual,
	setCookie,
	getCookie,
	getQueryString,
	setUrlQueryString,
	reloadPage,
	linkTo,
	redirectTo,
	empty,
	getRouteBaseUrl,
	getWindowHeight,
	getOnlineApiHost,
	getGetTokenUrl,
	parseUA,
	checkMobileFormat,
	addEventGa,
	preloadImages,
	canvasDrawPoster,
	arabiaToSimplifiedChinese,
	removeStrlrSpace,
	getClassNames,
	getOffset,
	getAppId,
	setPAMark,
	setPAMeasure,
	getPAMeasure
};



// WEBPACK FOOTER //
// ./src/util/util.js